import { Component, OnInit, Input, ContentChild } from "@angular/core";
import { FormControlName } from "@angular/forms"

@Component({
  selector: "flow-input-container",
  templateUrl: "./input-container.component.html",
  styleUrls: ["./input-container.component.scss"]
})
export class InputContainerComponent implements OnInit {

  @Input() label: string
  @Input() errorMessage: string
  @Input() showTip: boolean = true
  input: any
  infoTooltip: boolean = false
  @ContentChild(FormControlName) control: FormControlName

  constructor() { }

  ngOnInit() { }

  ngAfterContentInit() {
    this.input = this.control
    if (this.input === undefined) {
      throw new Error('Precisa usar diretiva formControlName')
    }
  }
  hasSuccess(): boolean {
    return this.input.valid && (this.input.dirty || this.input.touched)
  }

  hasError(): boolean {
    return this.input.invalid && (this.input.dirty || this.input.touched)
  }

  showInfo() {
    this.infoTooltip = !this.infoTooltip
  }

}
